import { Box, Skeleton, SkeletonText, HStack, IconButton, Icon } from '@chakra-ui/react';
import arrowRight from '../../../../assets/svg/arrowRight.svg?react';
import arrowLeft from '../../../../assets/svg/arrowLeft.svg?react';
const SliderSkeleton = () => {
  return (
    <Box
      width="auto"
      position="relative"
      height="100%"
      backgroundColor="#a3a3a3ff"
      borderRadius="xl"
      overflow="hidden"
    >
      {/* Background shimmer */}
      <Skeleton
        position="absolute"
        inset="0"
        startColor="gray.600"
        endColor="gray.700"
        fadeDuration={1}
      />

      {/* Bottom content box */}
      <Box
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        py={6}
        px={5}
        background="rgba(255, 255, 255, 0.2)"
        m={3}
        border="1px solid rgba(255, 255, 255, 0.2)"
        sx={{
          backdropFilter: 'blur(24px)',
        }}
      >
        {/* Title placeholder */}
        <Skeleton height="20px" width="80%" mb={2} startColor="gray.400" endColor="gray.500" />

        {/* Content placeholder */}
        <SkeletonText
          noOfLines={2}
          spacing="2"
          skeletonHeight="10px"
          width="95%"
          startColor="gray.400"
          endColor="gray.500"
        />

        {/* Arrows placeholders */}
        <HStack spacing="32px" mt={4} alignItems="center">
          <IconButton
            aria-label="Left Arrow"
            icon={<Icon as={arrowLeft} color="white" boxSize={3} />}
            size="md"
            borderRadius="full"
            border="1px solid rgba(255, 255, 255, 0.3)"
            bg="transparent"
            opacity={0.4}
            boxSize="12"
            _hover={{}}
            isDisabled
          />
          <IconButton
            aria-label="Right Arrow"
            icon={<Icon as={arrowRight} color="white" boxSize={3} />}
            size="md"
            borderRadius="full"
            border="1px solid rgba(255, 255, 255, 0.3)"
            bg="transparent"
            opacity={0.4}
            boxSize="12"
            _hover={{}}
            isDisabled
          />
        </HStack>
      </Box>
    </Box>
  );
};

export default SliderSkeleton;
